import React from 'react';
import MenuItem from './menu-item';
import InstitutionsScreen from './workspace-screens/institutions';
import InstituteScreen from './workspace-screens/institute';
import BeneficiariesScreen from './workspace-screens/beneficiaries';
import BeneficiaryScreen from './workspace-screens/beneficiary';
import ProgramsScreen from './workspace-screens/programs';
import ProgramScreen from './workspace-screens/program';
import ProductSelectScreen from './workspace-screens/product-select';
import ContractsScreen from './workspace-screens/contracts';
import ContractScreen from './workspace-screens/contract';
import ContractProgramsScreen from './workspace-screens/contract-programms';
import ContractProgramScreen from './workspace-screens/contract-program';
import EventsScreen from './workspace-screens/event/events-screen';
import EventScreen from './workspace-screens/event/event';
import EventParticipantScreen from './workspace-screens/event/event-participants';
import EventParticipantSelectScreen from './workspace-screens/event/participant-select';
import EventVolunteerScreen from './workspace-screens/event/event-volunteers';
import EventVolunteerSelectScreen from './workspace-screens/event/volunteers-select';
import EventTypeScreen from './workspace-screens/event/event-type';
import EventTypesScreen from './workspace-screens/event/event-types';
import EventGalleryScreen from './workspace-screens/event/event-gallery';
import EventDocsScreen from './workspace-screens/event/event-docs';

import TrainingsScreen from './workspace-screens/training/trainings';
import TrainingScreen from './workspace-screens/training/training';
import TrainingParticipantSelectScreen from './workspace-screens/training/training-participant-select';
import TrainingParticipantScreen from './workspace-screens/training/training-participants';

import ProductsScreen from './workspace-screens/products';
import ProductScreen from './workspace-screens/product';
import VolunteersScreen from './workspace-screens/volunteers';
import VolunteerScreen from './workspace-screens/volunteer'; 
import SupervisorScreen from './workspace-screens/supervisor'; 
import SupervisorsScreen from './workspace-screens/supervisors'; 


import RegionsScreen from './workspace-screens/regions';
import RegionScreen from './workspace-screens/region';
import LocationsScreen from './workspace-screens/locations';
import LocationScreen from './workspace-screens/location';
import UserScreen from './workspace-screens/user-screen';

import RefsScreen from './workspace-screens/refs-screen';
import RefScreen from './workspace-screens/ref-screen';

import SummaryRerport from './workspace-screens/summary-report';
import OrganizationScreen from './workspace-screens/project/organization';
import OrganizationsScreen from './workspace-screens/project/organizations';
import DonorScreen from './workspace-screens/project/donor';
import DonorsScreen from './workspace-screens/project/donors';
import PartnerScreen from './workspace-screens/project/partner';
import PartnersScreen from './workspace-screens/project/partners';
import ProjectsScreen from './workspace-screens/project/projects';
import ProjectScreen from './workspace-screens/project/project';
import ProjectProgramScreen from './workspace-screens/project/projectprogram';
import ProjectProgramsScreen from './workspace-screens/project/projectprograms';

import logo from '../img/polden_logo.png';

export default class Workspace extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            leftmenu: true,
            target : "top",
            arglist: new Map(), 
            role: sessionStorage.getItem("role") 
        };
    
        this.navigate= this.navigate.bind(this);
        this.goback = this.goback.bind(this);
    }

    navigate(target, args) {
        
        var arglist = this.state.arglist
        arglist.set(target, args)

        this.setState({
              target: target,  
              arglist: arglist
        })
    } 

    topNavigate(target) {
        this.setState({arglist: new Map(), 
                      target : "top"}, ()=>{this.navigate(target, {})})
        
    }

    goback(args) {
        var arglist = this.state.arglist
        if(args.caller) {
            var target = args.caller
            arglist.set(target, args.callargs)
            this.setState( {
                arglist: arglist, 
                target: target })
        } else {
            this.setState( {
                target: "top",
                arglist: new Map()
             })
        }
    } 

    render () {    
        const { leftmenu, role, target } = this.state;

        return (
            <div className="bg-light min-vh-100">
                {/* ВЕРХНЯЯ ПАНЕЛЬ */}
                <div className="bg-white border-bottom shadow-sm">
                    <div className="container-fluid">
                        <div
                            className="d-flex align-items-center justify-content-between"
                            style={{ height: "56px" }}
                        >
                            <div className="d-flex align-items-center">
                                {/* КНОПКА МЕНЮ */}
                                <button
                                    type="button"
                                    className="btn btn-outline-secondary d-flex align-items-center justify-content-center"
                                    style={{
                                        width: "40px",
                                        height: "40px",
                                        borderRadius: "8px",
                                    }}
                                    onClick={() => this.setState({ leftmenu: !leftmenu })}
                                >
                                    {leftmenu ? (
                                        <i className="bi bi-chevron-left" style={{ fontSize: "20px" }} />
                                    ) : (
                                        <i className="bi bi-list" style={{ fontSize: "24px" }} />
                                    )}
                                </button>

                                {/* НАЗВАНИЕ CRM */}
                                <span className="fw-semibold" style={{ marginLeft: "50px" }}>Полдень CRM</span>
                            </div>

                            {/* Место под что-то ещё справа, если захочешь (юзер, logout и т.п.) */}
                            <div />
                        </div>
                    </div>
                </div>

                {/* ОСНОВНОЙ КОНТЕЙНЕР */}
                <div className="container-fluid mt-3">
                    <div className="row gx-3">
                        {/* ЛЕВОЕ МЕНЮ */}
                        {leftmenu && (
                            <div className="col-md-3 col-lg-2 mb-3">
                                <div className="card shadow-sm h-100">
                                    <div className="card-body p-2">
                                        {["admin", "manager"].includes(role) && (
                                            <MenuItem
                                                title="Программы"
                                                onClick={() => { this.topNavigate("programs") }}
                                                active={target === "programs"}
                                            />
                                        )}

                                        {/*["admin", "manager"].includes(role) && (
                                            <MenuItem
                                                title="Контракты"
                                                onClick={() => { this.topNavigate("contracts") }}
                                                active={target === "contracts"}
                                            />
                                        )*/}

                                        {["admin", "manager"].includes(role) && (
                                            <MenuItem
                                                title="Продукты"
                                                onClick={() => { this.topNavigate("products") }}
                                                active={target === "products"}
                                            />
                                        )}

                                        <MenuItem
                                            title="Учреждения"
                                            onClick={() => { this.topNavigate("institutes") }}
                                            active={target === "institutes"}
                                        />
                                        <MenuItem
                                            title="События"
                                            onClick={() => { this.topNavigate("events") }}
                                            active={target === "events"}
                                        />
                                        {["admin", "manager"].includes(role) && (
                                            <MenuItem
                                                title="Типы событий"
                                                onClick={() => { this.topNavigate("event-types") }}
                                                active={target === "event-types"}
                                            />
                                        )}
                                        <MenuItem
                                            title="Участники"
                                            onClick={() => { this.topNavigate("beneficiaries") }}
                                            active={target === "beneficiaries"}
                                        />

                                        {["admin", "manager"].includes(role) && (
                                            <MenuItem
                                                title="Кураторы"
                                                onClick={() => { this.topNavigate("supervisors") }}
                                                active={target === "supervisors"}
                                            />
                                        )}
                                        <MenuItem
                                            title="Волонтеры"
                                            onClick={() => { this.topNavigate("volunteers") }}
                                            active={target === "volunteers"}
                                        />
                                        {/*
                                        <MenuItem
                                            title="Обучение"
                                            onClick={() => { this.topNavigate("trainings") }}
                                            active={target === "trainings"}
                                        />
                                        */}

                                        <MenuItem
                                            title="Регионы"
                                            onClick={() => { this.topNavigate("regions") }}
                                            active={target === "regions"}
                                        />
                                        <MenuItem
                                            title="Населенные пункты"
                                            onClick={() => { this.topNavigate("locations") }}
                                            active={target === "locations"}
                                        />
                                        {/*
                                        {["admin"].includes(role) && (
                                            <MenuItem
                                                title="Права доступа"
                                                onClick={() => {}}
                                                active={false}
                                            />
                                        )}
                                        */}

                                        {["admin", "manager"].includes(role) && (
                                        <div>        
                                        
                                        <MenuItem
                                            title="Сводный отчет"
                                            onClick={() => { this.topNavigate("summary-report") }}
                                            active={target === "summary-report"}
                                        />

                                        <MenuItem
                                            title="Проекты"
                                            onClick={() => { this.topNavigate("projects") }}
                                            active={target === "projects"}
                                        />

                                        <MenuItem
                                            title="Организации"
                                            onClick={() => { this.topNavigate("organizations") }}
                                            active={target === "organizations"}
                                        />

                                        <MenuItem
                                            title="Источники финансирования"
                                            onClick={() => { this.topNavigate("donors") }}
                                            active={target === "donors"}
                                        />

                                        <MenuItem
                                            title="Партнеры"
                                            onClick={() => { this.topNavigate("partners") }}
                                            active={target === "partners"}
                                        />
                                        </div>
                                        )}    
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* ПРАВАЯ ОБЛАСТЬ */}
                        <div className={leftmenu ? "col-md-9 col-lg-10" : "col-12"}>
                            {this.renderWorkspace()}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

        

    renderWorkspace() {
        return (
            <div>
                    {this.state.target === "top" && (
                        <div className="d-flex flex-column align-items-center justify-content-center"
                            style={{ height: "60vh", opacity: 0.7 }}>
                            <img src={logo} alt="Logo" style={{ height: "80px" }} />
                            <h5 className="mt-3">Центр управления программами и мероприятиями</h5>
                        </div>
                    )}
                    
                    {/*Programm   */}
                    {this.state.target == "programs" && <ProgramsScreen navigate={this.navigate} goback={this.goback} args={this.state.arglist.get("programs")}/>} 
                    {this.state.target == "program" && <ProgramScreen navigate={this.navigate} goback={this.goback} args={this.state.arglist.get("program")}/>}
                   
                    {/*Contract   */}
                    {this.state.target == "contracts" && <ContractsScreen navigate={this.navigate} goback={this.goback} args={this.state.arglist.get("contracts")}/>} 
                    {this.state.target == "contract" && <ContractScreen navigate={this.navigate} goback={this.goback} args={this.state.arglist.get("contract")}/>} 
                    {this.state.target == "contract-programs" && <ContractProgramsScreen navigate={this.navigate} goback={this.goback} args={this.state.arglist.get("contract-programs")}/>} 
                    {this.state.target == "contract-program" && <ContractProgramScreen navigate={this.navigate} goback={this.goback} args={this.state.arglist.get("contract-program")}/>} 


                    {/*Product   */}
                    {this.state.target == "products" && <ProductsScreen navigate={this.navigate} goback={this.goback} args={this.state.arglist.get("products")}/>}
                    {this.state.target == "product" && <ProductScreen navigate={this.navigate} goback={this.goback} args={this.state.arglist.get("product")}/>}
                    {this.state.target == "product-select" && <ProductSelectScreen navigate={this.navigate} goback={this.goback} args={this.state.arglist.get("product-select")}/>}

                    {/*Institute   */}                

                    {this.state.target == "institutes" && <InstitutionsScreen navigate={this.navigate} goback={this.goback} args={this.state.arglist.get("institutes")}/>}

                    {this.state.target == "institute" && <InstituteScreen navigate={this.navigate} goback={this.goback} args={this.state.arglist.get("institute")}/>}

                    {/*Event   */}             

                    {this.state.target == "events" && <EventsScreen navigate={this.navigate} goback={this.goback} args={this.state.arglist.get("events")}/>}

                    {this.state.target == "event" && <EventScreen navigate={this.navigate} goback={this.goback} args={this.state.arglist.get("event")}/>}

                    {this.state.target == "event-participant" && <EventParticipantScreen navigate={this.navigate} goback={this.goback} args={this.state.arglist.get("event-participant")}/>}

                    {this.state.target == "event-participant-select" && <EventParticipantSelectScreen navigate={this.navigate} goback={this.goback} args={this.state.arglist.get("event-participant-select")}/>}

                    {this.state.target == "event-volunteers" && <EventVolunteerScreen navigate={this.navigate} goback={this.goback} args={this.state.arglist.get("event-volunteers")}/>}

                    {this.state.target == "event-volunteers-select" && <EventVolunteerSelectScreen navigate={this.navigate} goback={this.goback} args={this.state.arglist.get("event-volunteers-select")}/>}

                    {this.state.target == "event-types" && <EventTypesScreen navigate={this.navigate} goback={this.goback} args={this.state.arglist.get("event-types")}/>}

                    {this.state.target == "event-type" && <EventTypeScreen navigate={this.navigate} goback={this.goback} args={this.state.arglist.get("event-type")}/>}

                    {this.state.target == "event-gallery"  && <EventGalleryScreen navigate={this.navigate} goback={this.goback} args={this.state.arglist.get("event-gallery")}/>}

                    {this.state.target == "event-docs"  && <EventDocsScreen navigate={this.navigate} goback={this.goback} args={this.state.arglist.get("event-docs")}/>}

                    {/*Trainings */}   

                    {this.state.target == "trainings" && <TrainingsScreen navigate={this.navigate} goback={this.goback} args={this.state.arglist.get("trainings")}/>}

                    {this.state.target == "training" && <TrainingScreen navigate={this.navigate} goback={this.goback} args={this.state.arglist.get("training")}/>}

                    {this.state.target == "training-participant" && <TrainingParticipantScreen navigate={this.navigate} goback={this.goback} args={this.state.arglist.get("training-participant")}/>}

                    {this.state.target == "training-participant-select" && <TrainingParticipantSelectScreen navigate={this.navigate} goback={this.goback} args={this.state.arglist.get("training-participant-select")}/>}


                    {/*Beneficiary   */}  

                    {this.state.target == "beneficiaries" && <BeneficiariesScreen navigate={this.navigate} goback={this.goback} args={this.state.arglist.get("beneficiaries")}/>}

                    {this.state.target == "beneficiary" && <BeneficiaryScreen navigate={this.navigate} goback={this.goback} args={this.state.arglist.get("beneficiary")}/>}

                    {/*Supervisor   */}
                    {this.state.target == "supervisors" && <SupervisorsScreen navigate={this.navigate} goback={this.goback} args={this.state.arglist.get("supervisors")}/> }
                    {this.state.target == "supervisor" && <SupervisorScreen navigate={this.navigate} goback={this.goback} args={this.state.arglist.get("supervisor")}/> }
                    {/*Volunteer   */}    
                    {this.state.target == "volunteers" && <VolunteersScreen navigate={this.navigate} goback={this.goback} args={this.state.arglist.get("volunteers")}/>}
                    {this.state.target == "volunteer" && <VolunteerScreen navigate={this.navigate} goback={this.goback} args={this.state.arglist.get("volunteer")}/>}

                    {/*regions*/}
                    {this.state.target == "regions" && <RegionsScreen navigate={this.navigate} goback={this.goback} args={this.state.arglist.get("regions")}/>}
                    {this.state.target == "region" && <RegionScreen navigate={this.navigate} goback={this.goback} args={this.state.arglist.get("region")}/>}

                    {/*locations*/}
                    {this.state.target == "locations" && <LocationsScreen navigate={this.navigate} goback={this.goback} args={this.state.arglist.get("locations")}/>}
                    {this.state.target == "location" && <LocationScreen navigate={this.navigate} goback={this.goback} args={this.state.arglist.get("location")}/>}

                    {/*user*/} 
                    {this.state.target == "user" && <UserScreen navigate={this.navigate} goback={this.goback} args={this.state.arglist.get("user")}/>}


                    {/*refs*/} 
                    {this.state.target == "refs" && <RefsScreen navigate={this.navigate} goback={this.goback} args={this.state.arglist.get("refs")}/>}    
                    {this.state.target == "ref" && <RefScreen navigate={this.navigate} goback={this.goback} args={this.state.arglist.get("ref")}/>} 

                    {/*report*/}
                    {this.state.target == "summary-report" && <SummaryRerport navigate={this.navigate} goback={this.goback} args={this.state.arglist.get("summary-report")}/>}  


                    {/*project*/} 
                    {this.state.target == "projects" && <ProjectsScreen navigate={this.navigate} goback={this.goback} args={this.state.arglist.get("projects")}/>}
                    {this.state.target == "project" && <ProjectScreen navigate={this.navigate} goback={this.goback} args={this.state.arglist.get("project")}/>}
                    {this.state.target == "projectprograms" && <ProjectProgramsScreen navigate={this.navigate} goback={this.goback} args={this.state.arglist.get("projectprograms")}/>}
                    {this.state.target == "projectprogram" && <ProjectProgramScreen navigate={this.navigate} goback={this.goback} args={this.state.arglist.get("projectprogram")}/>}

                    {/*organization*/}
                    {this.state.target == "organizations" && <OrganizationsScreen navigate={this.navigate} goback={this.goback} args={this.state.arglist.get("organizations")}/>}
                    {this.state.target == "organization" && <OrganizationScreen navigate={this.navigate} goback={this.goback} args={this.state.arglist.get("organization")}/>}

                    {/*donors*/}
                    {this.state.target == "donors" && <DonorsScreen navigate={this.navigate} goback={this.goback} args={this.state.arglist.get("donors")}/>}
                    {this.state.target == "donor" && <DonorScreen navigate={this.navigate} goback={this.goback} args={this.state.arglist.get("donor")}/>}

                    {/*partners*/}
                    {this.state.target == "partners" && <PartnersScreen navigate={this.navigate} goback={this.goback} args={this.state.arglist.get("partners")}/>}
                    {this.state.target == "partner" && <PartnerScreen navigate={this.navigate} goback={this.goback} args={this.state.arglist.get("partner")}/>}
            </div>  
        )
    }
}  





// WEBPACK FOOTER //
// ./src/ui/workspace.js